export function stringify(data) {
    if (data == null) {
        return null
    } else {
        return JSON.stringify(data)
    }
}
